import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import RoomPreview from '../components/RoomPreview';
import BusinessStayPreview from '../components/BusinessStayPreview';
import RestaurantPreview from '../components/RestaurantPreview';
import RegionPreview from '../components/RegionPreview';

const Home = () => {
  return (
    <>
      <Hero />
      <Features />
      <RoomPreview />
      <BusinessStayPreview />
      <RestaurantPreview />
      <RegionPreview />
    </>
  );
};

export default Home;
